import { Swiper, Pagination, Autoplay, EffectFade, Navigation } from 'swiper'

Swiper.use([Pagination, Autoplay, EffectFade, Navigation])

const fn = {
  init: () => {
    document.querySelectorAll('.keycontacts-slider').forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 1,
      speed: 500,
      autoplay: {
        delay: 6000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
    }

    if (numSlides > 1) {
      const swiperInstance = new Swiper(container, opts)

      // Listen for the "View Details" toggle event
      const toggleButton = el.closest('section').querySelector('[data-slide-toggle]')
      if (toggleButton) {
        toggleButton.addEventListener('click', () => {
          setTimeout(() => {
            swiperInstance.update() // Update Swiper after the section is expanded
          }, 300) // Delay to allow the section to fully expand
        })
      }
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
